import { Toast as ToastPrimitive } from "@base-ui/react/toast";
import { Button } from "./button";

const ToastList = () => {
	const { toasts } = ToastPrimitive.useToastManager();

	return toasts.map((toast) => (
		<ToastPrimitive.Root
			key={toast.id}
			toast={toast}
			className="data-ending-style:data-[swipe-direction=left]:transform-[translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))] data-ending-style:data-[swipe-direction=right]:transform-[translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))] data-expanded:data-ending-style:data-[swipe-direction=left]:transform-[translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))] data-expanded:data-ending-style:data-[swipe-direction=right]:transform-[translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))] transform-[translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)-(var(--toast-index)*var(--peek))-(var(--shrink)*var(--height))))_scale(var(--scale))] data-ending-style:data-[swipe-direction=down]:transform-[translateY(calc(var(--toast-swipe-movement-y)+150%))] data-ending-style:data-[swipe-direction=up]:transform-[translateY(calc(var(--toast-swipe-movement-y)-150%))] data-expanded:transform-[translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--offset-y)))] data-expanded:data-ending-style:data-[swipe-direction=down]:transform-[translateY(calc(var(--toast-swipe-movement-y)+150%))] data-expanded:data-ending-style:data-[swipe-direction=up]:transform-[translateY(calc(var(--toast-swipe-movement-y)-150%))] data-starting-style:transform-[translateY(150%)] [&[data-ending-style]:not([data-limited]):not([data-swipe-direction])]:transform-[translateY(150%)] absolute right-0 bottom-0 left-auto z-[calc(1000-var(--toast-index))] mr-0 h-(--height) w-full origin-bottom select-none rounded-lg border border-neutral-950 bg-white text-neutral-950 shadow-md transition-[transform_0.5s_cubic-bezier(0.22,1,0.36,1),opacity_0.5s,height_0.15s] [--gap:0.75rem] [--height:var(--toast-frontmost-height,var(--toast-height))] [--offset-y:calc(var(--toast-offset-y)*-1+calc(var(--toast-index)*var(--gap)*-1)+var(--toast-swipe-movement-y))] [--peek:0.75rem] [--scale:calc(max(0,1-(var(--toast-index)*0.1)))] [--shrink:calc(1-var(--scale))] after:absolute after:top-full after:left-0 after:h-[calc(var(--gap)+1px)] after:w-full after:content-[''] data-expanded:h-(--toast-height) data-ending-style:opacity-0 data-limited:opacity-0"
		>
			<ToastPrimitive.Content className="flex h-full items-center gap-4 overflow-hidden p-3 transition-opacity duration-250 ease-[cubic-bezier(0.22,1,0.36,1)] data-behind:opacity-0 data-expanded:opacity-100">
				<div className="flex min-w-0 flex-1 flex-col gap-1">
					<ToastPrimitive.Title className="font-medium text-sm" />

					<ToastPrimitive.Description className="text-sm" />
				</div>

				<Button
					size="sm"
					variant="black"
					render={<ToastPrimitive.Close>Fechar</ToastPrimitive.Close>}
				></Button>
			</ToastPrimitive.Content>
		</ToastPrimitive.Root>
	));
};

const Toast = ({ children }: { children: React.ReactNode }) => {
	return (
		<ToastPrimitive.Provider>
			{children}

			<ToastPrimitive.Portal>
				<ToastPrimitive.Viewport className="fixed top-auto right-4 bottom-4 z-1 mx-auto w-[calc(100vw-2rem)] sm:right-8 sm:bottom-8 sm:w-90">
					<ToastList />
				</ToastPrimitive.Viewport>
			</ToastPrimitive.Portal>
		</ToastPrimitive.Provider>
	);
};

const useToastManager = ToastPrimitive.useToastManager;

export { Toast, useToastManager };
